import type { State } from '@chessshooter/shared';
import { TIME_LOSS_STYLE } from './uiConstants';

/** Consume confirmed totals, independent of clock drain, phase prediction and skipped snapshots. */
export class HitFeedback {
  private totals: [number, number] | null = null;

  update(state: State): [number, number] {
    const next: [number, number] = [state.players[0].hitTimeLostMs, state.players[1].hitTimeLostMs];
    const losses: [number, number] = this.totals
      ? [Math.max(0, next[0] - this.totals[0]), Math.max(0, next[1] - this.totals[1])]
      : [0, 0];
    this.totals = next;
    return losses;
  }
}

interface TimeLossPopup {
  ms: number;
  startedAt: number;
}

/** Merge rapid hits so their full cost stays readable; real time also expires badges after a win. */
export class TimeLossPopups {
  private labels: [TimeLossPopup | null, TimeLossPopup | null] = [null, null];

  update(losses: readonly [number, number], now: number): readonly (TimeLossPopup | null)[] {
    for (const id of [0, 1] as const) {
      const previous = this.labels[id];
      if (previous && now - previous.startedAt >= TIME_LOSS_STYLE.durationMs) this.labels[id] = null;
      if (losses[id] > 0) {
        this.labels[id] = { ms: (this.labels[id]?.ms ?? 0) + losses[id], startedAt: now };
      }
    }
    return this.labels;
  }

  reset(): void { this.labels = [null, null]; }
}

export function formatHitLoss(ms: number): string {
  return `−${Number((ms / 1000).toFixed(3)).toLocaleString('de-DE', { maximumFractionDigits: 3 })} s`;
}
